import { useNavigation } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, Text, View } from 'react-native';
import { useDispatch } from 'react-redux';

import { BtnCloseModal } from '../../../assets';
import { testProps } from '../../../config';
import { analyticsEvents } from '../../../services/firebase/analytics-events.service';
import { myTablesRequest } from '../../../store/lobby/lobbyActions';
import { useDevice } from '../../../utils/hooks/useDevice';
import { RootStackParamList } from '../../navigator';
import { TouchableOpacity } from '../common/Touchable';
import SvaraModal from './SvaraModal';

type Nav = NativeStackNavigationProp<RootStackParamList>;
interface JoinTournamentModalProps {
	onClose: () => void;
	tournamentId: string;
}

function JoinTournamentModal({ onClose, tournamentId }: JoinTournamentModalProps) {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	analyticsEvents.trackTournamentRegister('join');
	useEffect(() => {
		dispatch(myTablesRequest());
	}, [dispatch]);

	const { isXs } = useDevice();

	const { navigate } = useNavigation<Nav>();

	return (
		<SvaraModal
			visible
			onClose={onClose}
			closeIcon={BtnCloseModal}
			bigCloseButton
			bigCloseBtnStyles={{
				width: 42,
				height: 42,
				...(isXs && { transform: [{ translateX: 11 }, { translateY: -10 }] }),
			}}
		>
			{/* Title */}
			<Text style={styles.title}>
				{t('T_SITE_TOURNAMENT_STARTING_SOON', {
					defaultValue: 'Tournament will start soon. Join it',
				})}
			</Text>

			{/* Buttons */}
			<View style={styles.actionsRow}>
				{/* REFUSE */}
				<TouchableOpacity
					onPress={() => onClose()}
					style={styles.refuseBtn}
					{...testProps('cta-join-tournament-refuse')}
				>
					<Text style={styles.refuseText}>{t('T_SITE_DENY', { defaultValue: 'Refuse' })}</Text>
				</TouchableOpacity>

				{/* ACCEPT */}
				<TouchableOpacity
					onPress={() => {
						onClose();
						navigate('Game', { tableId: tournamentId, isTournamentRoom: true });
					}}
					style={styles.acceptBtn}
					{...testProps('cta-join-tournament-accept')}
				>
					<Text style={styles.acceptText}>{t('T_SITE_ACCEPT', { defaultValue: 'Accept' })}</Text>
				</TouchableOpacity>
			</View>
		</SvaraModal>
	);
}

const styles = StyleSheet.create({
	title: {
		color: 'white',
		fontSize: 22,
		fontWeight: '700',
		textAlign: 'center',
		marginBottom: 24,
		textTransform: 'uppercase',
	},
	actionsRow: {
		flexDirection: 'row',
		justifyContent: 'space-evenly',
		alignItems: 'center',
		width: '100%',
		marginTop: 8,
	},
	refuseBtn: {
		minWidth: 120,
		paddingVertical: 10,
		paddingHorizontal: 16,
		borderRadius: 24,
		borderWidth: 1,
		borderColor: '#ffffff77',
		alignItems: 'center',
	},
	refuseText: {
		color: '#ffffffdd',
		fontSize: 16,
		fontWeight: '600',
	},
	acceptBtn: {
		minWidth: 120,
		paddingVertical: 10,
		paddingHorizontal: 16,
		borderRadius: 24,
		backgroundColor: '#F0B223',
		alignItems: 'center',
	},
	acceptText: {
		color: '#1b0f09',
		fontSize: 16,
		fontWeight: '700',
	},
});

export default JoinTournamentModal;
